module.exports = __webpack_public_path__ + "media/images/h-icon-a8c9b64e5e505ac29f46f29652fbb52c.svg";